import request from "../../../../api/index";

export default class {
  // 删除
  static deleteProperty = (params) => {
    return request('GET', 'attribute/delete', params)
  }
}
